<template>
  <b-card
    body
    body-class="!p-0"
  >
    <div class="p-[21px]">
      <div class="flex justify-between text-black my-[10px]">
        <div class="d-flex align-items-center justify-between">
          <h2 class="text-black font-semibold text-2xl mb-0">
            Bahan Packing
          </h2>
        </div>
      </div>
      <div class="flex items-center justify-between gap-2 mt-[20px]">
        <div class="flex items-center gap-2">
          <b-button
            pill
            :variant="isKonfirmasi ? 'primary' : 'light'"
            size="sm"
            class="rounded-lg !py-[12px] !px-[24px] !flex items-center gap-2"
            @click="handleChangeTab('konfirmasi')"
          >
            Konfirmasi
            <!-- <span class="bg-[#E2E2E2] text-[#333333] rounded-full p-[4px]">
              4
            </span> -->
          </b-button>
          <b-button
            pill
            :variant="isPengajuan ? 'primary' : 'light'"
            size="sm"
            class="rounded-lg !py-[12px] !px-[24px] !flex items-center gap-2"
            @click="handleChangeTab('pengajuan')"
          >
            Pengajuan
            <!-- <span class="bg-[#E2E2E2] text-[#333333] rounded-full p-[4px]">
              4
            </span> -->
          </b-button>
        </div>

        <b-button
          variant="primary"
          size="sm"
          class="mr-1 rounded-lg !p-[12px] !flex items-center gap-2"
          @click="tambahBahanPacking"
        >
          <feather-icon
            size="1x"
            icon="PlusIcon"
          />
          Tambah Bahan Packing
        </b-button>
      </div>
    </div>
    <div class="mb-[21px]">
      <BahanPackingConfirmed
        v-if="isKonfirmasi"
        ref="bahanPackingConfirmed"
        @request-edit="handleRequestEdit"
        @request-delete="handleRequestDelete"
        @request-view-detail="handleRequestViewDetail"
      />
      <BahanPackingPengajuan
        v-if="isPengajuan"
        ref="bahanPackingPengajuan"
        @request-edit="handleRequestEdit"
        @request-delete="handleRequestDelete"
        @request-view-detail="handleRequestViewDetail"
      />
    </div>

    <ModalViewDetailBahanPacking
      ref="modalViewDetailBahanPacking"
    />

    <ModalTambahBahanPacking
      ref="modalTambahBahanPacking"
      @confirmed="handleConfirmedAction"
    />

    <ModalEditBahanPacking
      ref="modalEditBahanPacking"
      @confirmed="handleConfirmedAction"
    />

    <ModalDeleteBahanPacking
      ref="modalDeleteBahanPacking"
      @success="handleDeletingAction"
    />
  </b-card>
</template>

<script>
import BahanPackingConfirmed from './components/BahanPackingConfirmed.vue'
import BahanPackingPengajuan from './components/BahanPackingPengajuan.vue'
import ModalTambahBahanPacking from './components/ModalTambahBahanPacking.vue'
import ModalEditBahanPacking from './components/ModalEditBahanPacking.vue'
import ModalDeleteBahanPacking from './components/ModalDeleteBahanPacking.vue'
import ModalViewDetailBahanPacking from './components/ModalViewDetailBahanPacking.vue'

export default {
  name: 'BahanPacking',
  components: {
    BahanPackingConfirmed,
    BahanPackingPengajuan,
    ModalTambahBahanPacking,
    ModalEditBahanPacking,
    ModalDeleteBahanPacking,
    ModalViewDetailBahanPacking,
  },
  data() {
    return {
      activeTab: this.$route.query.tab || 'konfirmasi',
    }
  },
  computed: {
    isKonfirmasi() {
      return this.activeTab === 'konfirmasi'
    },
    isPengajuan() {
      return this.activeTab === 'pengajuan'
    },
  },
  methods: {
    handleChangeTab(tab) {
      this.activeTab = tab
      this.$router.push({ query: { tab } })
    },
    tambahBahanPacking() {
      this.$refs.modalTambahBahanPacking.show()
    },
    /**
     * Handle confirmed action (Edit and Add), pengajuan data will be refreshed
     * or change tab to pengajuan if confirmed data is from konfirmasi
     */
    async handleConfirmedAction() {
      if (this.isPengajuan) {
        this.$refs.bahanPackingPengajuan.refreshData()
      } else {
        this.handleChangeTab('pengajuan')
      }
      this.$refs.modalTambahBahanPacking.handleCloseModal()
    },
    handleRequestEdit(payload) {
      this.$refs.modalEditBahanPacking.show(payload)
    },
    /**
     * Handle deleting action, pengajuan data or confirmed data will be refreshed
     */
    handleDeletingAction() {
      if (this.isPengajuan) {
        this.$refs.bahanPackingPengajuan.refreshData()
        return
      }

      this.$refs.bahanPackingConfirmed.refreshData()
    },
    handleRequestDelete(payload) {
      this.$refs.modalDeleteBahanPacking.show(payload)
    },
    handleRequestViewDetail(payload) {
      this.$refs.modalViewDetailBahanPacking.show(payload)
    },
  },
}
</script>
